export const AUTH_CODE_LENGTH = 4;
export const POLISH_COUNTRY_CODE = '+48';
export const REFERRAL_CODE_PREFIX = 'REF-';
export const REFERRAL_CODE_PATTERN = /^REF-[A-Z]{4}$/;
